import { useState } from "react";
import axios from 'axios'
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { notification, Tooltip } from 'antd';


import CredentialPopup from "../../../../component/common/CredentialPopup";
import SAISVG from "../../../../../_template/helpers/CommonFunction";
import { base64Encode, getShortForm } from "../../../../component/common/Helper";

const TableRow = (props) => {
    const loginUserType = localStorage.getItem('type');
    const bot_url = process.env.REACT_APP_BOT_URL;
    const api_base_url = process.env.REACT_APP_API_URL;
    const [api, contextHolder] = notification.useNotification();

    const handelCheckbox = async(event) => {

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        
        try {
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            api_params.status = event.target.checked ? "Y" : "N";
            api_params.sys_admin_id = props.row.system_admin_id;

            await axios.post(`${api_base_url}admin/sysadmin-active-status-change`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        api["success"]({
                            message: 'Success',
                            description: res.data.message
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                }) 
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }
    const handelDelete = async() => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        const sysAdminDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (sysAdminDeleteSwal.isConfirmed) {
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            api_params.sys_admin_id = props.row.system_admin_id;

            await axios.post(`${api_base_url}admin/delete-system-admin`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        api["success"]({
                            message: 'Success',
                            description: res.data.message
                        });
                        props.deleteSuccess({system_admin_id: props.row.system_admin_id});
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }
    const handelEdit = async() => {
        props.editId({system_admin_id: props.row.system_admin_id});
    }

    let assignBusinessHtml = '';
    if( props.row.assigned_business.length > 0){
        assignBusinessHtml = props.row.assigned_business.map((assignBusiness) => 
            <span className="me-2" key={assignBusiness.id}>
                <div className="badge badge-light-primary fw-bold mb-1">
                    {assignBusiness.business_name}
                </div>
            </span>
        )
    }
    return (
        <>
        <tr>
            <td>
                <div className="d-flex align-items-center border-none">
                    <div className="symbol symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                <span className="symbol-label fs-2x fw-bold text-primary text-uppercase">{getShortForm(props.row.name)}</span>
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {props.row.name}
                        </a>
                        {/* <div className="d-flex">
                            {props.row.allow_voice == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Voice</div>
                            </span>}
                            {props.row.allow_attachment == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Attachment</div>
                            </span>}
                            {props.row.allow_survey == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Survey</div>
                            </span>}
                        </div> */}
                    </div>
                </div>
            </td>
            <td>
                <span className="me-2">
                    <Tooltip title="Hook URL">
                        <div className="badge badge-light-primary fw-bold mb-2">{props.row.email}</div>
                    </Tooltip>
                </span>
            </td>
            <td>
                {assignBusinessHtml}
            </td>
            <td>
                {/* <div className="d-flex mb-4 float-end">
                    <button className="btn btn-sm btn-icon btn-light-primary me-3 px-4" onClick={handelEdit}>
                        <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                    {props.row.widget_type == "E" && <button 
                        className="btn btn-sm btn-icon btn-light-danger px-4"
                        onClick={handelDelete}
                    >
                        <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                    </button>}
                </div> */}
                <div className="d-flex mb-4 float-end">
                    <div className="form-check form-switch m-auto">
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            defaultChecked={props.row.active_status === 'Y' ? true : false}
                            onChange={handelCheckbox}
                        />
                    </div>
                    <button 
                        className="btn btn-sm btn-icon btn-light-dark me-3 px-4"
                        data-sai-menu-trigger='click'
                        data-sai-menu-placement='bottom-end'
                        data-sai-menu-flip='top-end'
                    >
                        <SAISVG path="media/icons/duotune/general/gen047.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                    <CredentialPopup
                        title='System User Credential'
                        username={props.row.username}
                        password={atob(props.row.password)}
                    />
                    <button 
                        className="btn btn-sm btn-icon btn-light-primary me-3 px-4"
                        onClick={handelEdit}
                    >
                        <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                    <button 
                        className="btn btn-sm btn-icon btn-light-danger px-4"
                        onClick={handelDelete}
                    >
                        <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                </div>
            </td>
        </tr>
        {contextHolder}
        </>
    )
}

export default TableRow;